<div class="direct-subnav">
  <span *ngIf="isPremium$ | async" class="hidden md:block direct-premium-badge badge badge-grass">Premium</span>

  <h4 [routerLink]="['/direct']" [class.active-header]="activeNavArea === 'overview'" class="flex gap-3 items-center">
    <img
      src="/assets/iconography/nav-direct.svg"
      onload="SVGInject(this)"
      alt="Direct Overview"
      class="w-5 flex-shrink-0" />
    <span class="flex-1">Overview</span>
  </h4>

  <ng-container *ngIf="isOnboarded$ | async">
    <ng-container *ngIf="(isLite$ | async) === false && (shouldDisplayFinancialData$ | async) === true">
      <div class="h-px w-full bg-gray-200 my-4 mobile-separator sbnbDesktop:hidden" data-section-separator></div>
      <h4
        [routerLink]="['/direct/payout-history']"
        [class.active-header]="activeNavArea === 'payouts'"
        class="flex gap-3 items-center no-details">
        <img src="assets/iconography/subtotal.svg" class="w-5 flex-shrink-0" onload="SVGInject(this)" />
        <span class="flex-1">Payouts</span>
      </h4>

      <div class="subnav-items">
        <div class="subnav-item" [routerLink]="['/direct/payout-history']" routerLinkActive="active-link">
          Payout History
        </div>

        <div class="subnav-item" [routerLink]="['/direct/payouts']" routerLinkActive="active-link">Payout Methods</div>
      </div>
    </ng-container>
    <div class="h-px w-full bg-gray-200 my-4 mobile-separator sbnbDesktop:hidden" data-section-separator></div>
    <h4
      [routerLink]="['/direct/booking-policies']"
      class="flex gap-3 items-center no-details"
      [class.active-header]="activeNavArea === 'bookings'">
      <img src="/assets/iconography/date.svg" class="w-5 flex-shrink-0" onload="SVGInject(this)" />
      <span class="flex-1">Bookings</span>
    </h4>

    <div class="subnav-items">
      <div class="subnav-item" [routerLink]="['/direct/booking-policies']" routerLinkActive="active-link">
        Booking Policies
      </div>

      <div
        *ngIf="(isLite$ | async) === false"
        class="subnav-item"
        [routerLink]="['/direct/channels']"
        routerLinkActive="active-link">
        Channels
      </div>

      <div
        *ngIf="instantBookEnabled$ | async"
        class="subnav-item"
        [routerLink]="['/direct/instant-book']"
        routerLinkActive="active-link">
        Instant Book
      </div>

      <div class="subnav-item" [routerLink]="['/direct/promotions']" routerLinkActive="active-link">Promo Codes</div>
    </div>
  </ng-container>

  <ng-container *ngIf="(isOnboarded$ | async) && (isPremium$ | async) && (shouldDisplayEarningReports$ | async)">
    <div class="h-px w-full bg-gray-200 my-4 mobile-separator sbnbDesktop:hidden" data-section-separator></div>
    <h4
      [routerLink]="['/direct/earnings-reports']"
      [class.active-header]="activeNavArea === 'earnings-reports'"
      class="flex gap-3 items-center no-details">
      <sbnb-icon icon="calculator" [size]="18"></sbnb-icon>
      <span class="flex-1">Taxes</span>
    </h4>

    <div class="subnav-items">
      <div class="subnav-item" [routerLink]="['/direct/earnings-reports']" routerLinkActive="active-link">
        Annual Earnings Reports
      </div>
    </div>
    <div class="h-px w-full bg-gray-200 my-4 mobile-separator sbnbDesktop:hidden" data-section-separator></div>
  </ng-container>

  <h4
    *ngIf="(isPrimaryUser$ | async) && (isOnboarded$ | async)"
    [routerLink]="['/direct/plan']"
    [class.active-header]="activeNavArea === 'plan'"
    class="flex gap-3 items-center">
    <img
      src="/assets/iconography/nav/nav-subscription.svg"
      alt="Direct Your Plan"
      class="w-5 flex-shrink-0"
      onload="SVGInject(this)" />
    <span class="flex-1">Your Plan</span>
  </h4>
</div>
